import {useMatchMedia} from '@pexip/hooks';

import {MOBILE_DEVICE_LANDSCAPE} from '../../constants/mediaQueries';

export const useMobileDeviceLandscape = () =>
    useMatchMedia(MOBILE_DEVICE_LANDSCAPE);
